import { proxy, ref } from 'valtio';

import { type BecsyAnalyzer, noopAnalyzer } from '@canvas/becsy-analyzer';

interface AnalyzerState {
  enabled: boolean;
  analyzer: BecsyAnalyzer;
}

export const currentBecsyAnalyzer = proxy<AnalyzerState>({
  enabled: false,
  analyzer: ref(noopAnalyzer),
});
